export default "__VITE_ASSET__dc741842__"